
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-mask\">\n  <div class=\"l-input\">\n    <input type=\"text\" name=\"content\" class=\"c-barrage__input\" placeholder=\"")
    ; __append(escape(desc))
    ; __append("\" />\n    <span class=\"c-barrage__send disable\">发送</span>\n  </div>\n  <div class=\"l-padding\"></div>\n</div>\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/input/main.ejs
// module id = 598
// module chunks = 0